import { EmailConfigView } from "../interfaces/EmailConfig"
import request from "./axios"
import { UserInfoSearchForm } from "../interfaces/UserInfo"
import { MatchResultSearchForm } from "../interfaces/MatchResult"
import { AssistanceSearchForm } from "../interfaces/Assistance"
import { DonationSearchForm } from "../interfaces/Donation"
import { UpgradeSearchForm } from "../interfaces/Upgrade"
import { Admin } from "../interfaces/Admin"

const isProductEnvironment = process.env.REACT_APP_IS_PROD_ENV
const baseUrl = isProductEnvironment? 'https://www.ykytools.top/api' :'http://localhost:8080/api'

export const login =()=>{
//    window.location.href=baseUrl+'/oauth2/authorization/google'
 window.location.href=baseUrl+'/oauth2/authorization/github'
}

export const logout =()=>{
   window.location.href=baseUrl+'/logout'
}

export const loginInfo =()=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/loginInfo',
            method:'get',
        }
    )
 }
 
export const getEmailConfig=()=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/emailConfigs',
            method:'get'
        }
    )
}

export const modifyEmailConfig=(config:EmailConfigView)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/emailConfigs/'+config.key,
            method:'post',
            data:config
        }
    )
}

export const searchAssistance = (searchForm:AssistanceSearchForm)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/assistances',
            method:'post',
            params:searchForm.params,
            data:searchForm.filters
        }
    )
}

export const searchDonation = (searchForm:DonationSearchForm)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/donations',
            method:'post',
            params:searchForm.params,
            data:searchForm.filters
        }
    )
}

export const searchUpgrade = (searchForm:UpgradeSearchForm)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/upgrades',
            method:'post',
            params:searchForm.params,
            data:searchForm.filters
        }
    )
}

export const seachUserInfo=(searchForm:UserInfoSearchForm)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/userInfos',
            method:'post',
            params:searchForm.params,
            data:searchForm.filters
        }
    )
}

export const searchMatchResult=(searchForm:MatchResultSearchForm)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/matchResults/search',
            method:'post',
            params:searchForm.params,
            data:searchForm.filters
        }
    )
}

export const executeMatch=()=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/matchResults/match',
            method:'post',
            responseType: 'blob'
        }
    )
}

export const listAdmins=()=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/admins',
            method:'get',
        }
    )
}

export const createAdmin=(creationModel:Admin)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/admins',
            method:'post',
            data:creationModel
        }
    )
}

export const modifyAdmin=(creationModel:Admin)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/admins/'+creationModel.oauthId,
            method:'post',
            data:creationModel
        }
    )
}

export const deleteAdmin=(creationModel:Admin)=>{
    return request(
        {
            baseURL:baseUrl,
            url:'/admins/'+creationModel.oauthId,
            method:'delete',
        }
    )
}
